export const COLOR_KEY = "color"
export const RADIUS_KEY = "radius"

export const NO_CATEGORY = "none"
